import { Product } from '../../types';

export const series090Products: Product[] = [
  {
    id: "bt-090-swt009001f",
    name: "090 Series Terminal - 2.2 Female (SWT009001F)",
    slug: "090-series-terminal-2-2-female-swt009001f",
    category: "Brass Terminal",
    subcategory: "090 Series",
    description: "090 Series female terminal (2.2mm) for automotive connectors. High conductivity brass construction.",
    partNumber: "SWT009001F",
    specifications: {
      "Tab Size Ø": "2.2 mm",
      "Cable Size SQ. MM": "1.40-2.00",
      "Description": "2.2 Female",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-3500 Cut-1000",
    },
    images: ["/products/brass-terminals/090-series/SWT009001F.jpg"],
    tags: ["terminal", "090", "brass", "female", "2.2mm"],
    applications: ["Automotive", "Connectors"],
  },
  {
    id: "bt-090-swt009001m",
    name: "090 Series Terminal - 2.2 Male (SWT009001M)",
    slug: "090-series-terminal-2-2-male-swt009001m",
    category: "Brass Terminal",
    subcategory: "090 Series",
    description: "090 Series male terminal (2.2mm) for automotive connectors. High conductivity brass construction.",
    partNumber: "SWT009001M",
    specifications: {
      "Tab Size Ø": "2.2 mm",
      "Cable Size SQ. MM": "1.40-2.00",
      "Description": "2.2 Male",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-3500 Cut-1000",
    },
    images: ["/products/brass-terminals/090-series/SWT009001M.jpg"],
    tags: ["terminal", "090", "brass", "male", "2.2mm"],
    applications: ["Automotive", "Connectors"],
  },
  {
    id: "bt-090-swt009002f",
    name: "090 Series Terminal - 2.2 Female Water Proof (SWT009002F)",
    slug: "090-series-terminal-2-2-female-waterproof-swt009002f",
    category: "Brass Terminal",
    subcategory: "090 Series",
    description: "090 Series female terminal (2.2mm) with waterproof feature for automotive connectors. High conductivity brass construction.",
    partNumber: "SWT009002F",
    specifications: {
      "Tab Size Ø": "2.2 mm",
      "Cable Size SQ. MM": "1.50-2.30",
      "Description": "2.2 Female Water Proof",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-3500 Cut-1000",
    },
    images: ["/products/brass-terminals/090-series/SWT009002F.jpg"],
    tags: ["terminal", "090", "brass", "female", "2.2mm", "waterproof"],
    applications: ["Automotive", "Connectors"],
  },
  {
    id: "bt-090-swt009002m",
    name: "090 Series Terminal - 2.2 Male Water Proof (SWT009002M)",
    slug: "090-series-terminal-2-2-male-waterproof-swt009002m",
    category: "Brass Terminal",
    subcategory: "090 Series",
    description: "090 Series male terminal (2.2mm) with waterproof feature for automotive connectors. High conductivity brass construction.",
    partNumber: "SWT009002M",
    specifications: {
      "Tab Size Ø": "2.2 mm",
      "Cable Size SQ. MM": "1.50-2.30",
      "Description": "2.2 Male Water Proof",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-3500 Cut-1000",
    },
    images: ["/products/brass-terminals/090-series/SWT009002M.jpg"],
    tags: ["terminal", "090", "brass", "male", "2.2mm", "waterproof"],
    applications: ["Automotive", "Connectors"],
  },
  {
    id: "bt-090-swt009003f",
    name: "090 Series Terminal - 2.2 Female Lock Water Proof (SWT009003F)",
    slug: "090-series-terminal-2-2-female-lock-waterproof-swt009003f",
    category: "Brass Terminal",
    subcategory: "090 Series",
    description: "090 Series female terminal (2.2mm) with lock and waterproof features for automotive connectors. High conductivity brass construction.",
    partNumber: "SWT009003F",
    specifications: {
      "Tab Size Ø": "2.2 mm",
      "Cable Size SQ. MM": "1.50-2.30",
      "Description": "2.2 Female Lock Water Proof",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-3500 Cut-1000",
    },
    images: ["/products/brass-terminals/090-series/SWT009003F.jpg"],
    tags: ["terminal", "090", "brass", "female", "2.2mm", "waterproof", "lock"],
    applications: ["Automotive", "Connectors"],
  },
];
